var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlidesGridBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 545,
    viewBox: "0 0 542 545",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.4219 0V544.124",
    stroke: "url(#paint0_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.32 0V544.124",
    stroke: "url(#paint1_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M213.215 0V544.124",
    stroke: "url(#paint2_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M279.113 0V544.124",
    stroke: "url(#paint3_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M345.012 0V544.124",
    stroke: "url(#paint4_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M410.91 0V544.124",
    stroke: "url(#paint5_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M476.812 0V544.124",
    stroke: "url(#paint6_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 497.547L542 497.547",
    stroke: "url(#paint7_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 431.594L542 431.594",
    stroke: "url(#paint8_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 365.641L542 365.641",
    stroke: "url(#paint9_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 299.684L542 299.684",
    stroke: "url(#paint10_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 233.73L542 233.73",
    stroke: "url(#paint11_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 167.777L542 167.777",
    stroke: "url(#paint12_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 101.82L542 101.82",
    stroke: "url(#paint13_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 35.8672L542 35.8672",
    stroke: "url(#paint14_linear_1877_14093)",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_14093",
    x1: 81.9219,
    y1: 0,
    x2: 81.9219,
    y2: 544.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1877_14093",
    x1: 147.82,
    y1: 0,
    x2: 147.82,
    y2: 544.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1877_14093",
    x1: 213.715,
    y1: 0,
    x2: 213.715,
    y2: 544.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1877_14093",
    x1: 279.613,
    y1: 0,
    x2: 279.613,
    y2: 544.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1877_14093",
    x1: 345.512,
    y1: 0,
    x2: 345.512,
    y2: 544.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1877_14093",
    x1: 411.41,
    y1: 0,
    x2: 411.41,
    y2: 544.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1877_14093",
    x1: 477.312,
    y1: 0,
    x2: 477.313,
    y2: 544.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1877_14093",
    x1: 0,
    y1: 497.047,
    x2: 542,
    y2: 497.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1877_14093",
    x1: 0,
    y1: 431.094,
    x2: 542,
    y2: 431.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1877_14093",
    x1: 0,
    y1: 365.141,
    x2: 542,
    y2: 365.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1877_14093",
    x1: 0,
    y1: 299.184,
    x2: 542,
    y2: 299.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1877_14093",
    x1: 0,
    y1: 233.23,
    x2: 542,
    y2: 233.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1877_14093",
    x1: 0,
    y1: 167.277,
    x2: 542,
    y2: 167.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1877_14093",
    x1: 0,
    y1: 101.32,
    x2: 542,
    y2: 101.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1877_14093",
    x1: 0,
    y1: 35.3672,
    x2: 542,
    y2: 35.3672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidesGridBg);
export default __webpack_public_path__ + "static/media/SlidesGridBg.c4b222830124b7a5ec27f00fbe8a1a21.svg";
export { ForwardRef as ReactComponent };